import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface UnitSuggestion {
  id: string
  locationId: string
  idMotion: number
  name: string
  type: string
  street: string
  neighborhood: string
  city: string
  state: string
  zipCode: string
  distance: number
  earliestDate: string
}

export interface PrivateSuggestion extends UnitSuggestion {
  flow?: 'doctor' | 'specialty'
}

interface FallbackStore {
  hasNoResultsFilter: boolean
  suggestion: UnitSuggestion[]
  privateSuggestion?: PrivateSuggestion
  setHasNoResultsFilter: (hasNoResultsFilter: boolean) => void
  setSuggestion: (suggestion: UnitSuggestion[]) => void
  setPrivateSuggestion: (suggestion: PrivateSuggestion) => void
  reset: () => void
}

type InitialStateStore = Omit<
  FallbackStore,
  | 'hasNoResultsFilter'
  | 'suggestion'
  | 'privateSuggestion'
  | 'setHasNoResultsFilter'
  | 'setSuggestion'
  | 'setPrivateSuggestion'
  | 'reset'
>

const initialState: InitialStateStore = {
  hasNoResultsFilter: undefined,
  suggestion: undefined,
  privateSuggestion: undefined
}

export const useFallbackStore = create<FallbackStore>()(
  devtools((set) => ({
    suggestion: [],
    hasNoResultsFilter: false,
    setHasNoResultsFilter(hasNoResultsFilter) {
      set({ hasNoResultsFilter }, false, 'setHasNoResultsFilter')
    },
    setSuggestion(suggestion) {
      set({ suggestion }, false, 'setSuggestion')
    },
    setPrivateSuggestion(privateSuggestion) {
      set({ privateSuggestion }, false, 'setPrivateSuggestion')
    },
    reset: () => {
      set(initialState)
    }
  }))
)
